module.exports = __webpack_public_path__ + "static/media/DragDrop.184ffa33.svg";